import type { VariantType } from 'notistack'

import { CLOSE_SNACKBAR, ENQUEUE_SNACKBAR, REMOVE_SNACKBAR } from './constants'
import type { NotificationAction } from './types'

interface EnqueueSnackbarProps {
  message: string
  variant?: VariantType
}

export function enqueueSnackbar({ message, variant = 'default' }: EnqueueSnackbarProps): NotificationAction {
  return {
    type: ENQUEUE_SNACKBAR,
    key: new Date().getTime() + Math.random(),
    payload: {
      message,
      variant,
    },
  }
}

export const closeSnackbar = (key: string) => ({
  type: CLOSE_SNACKBAR,
  dismissAll: !key, // dismiss all if no key has been defined
  key,
})

export const removeSnackbar = (key: string) => ({
  type: REMOVE_SNACKBAR,
  key,
})
